import React, { useEffect, useState, useRef, useCallback } from "react";
import "./video.css";
import { motion } from 'framer-motion';

export default function Video() {
  const [videos, setVideos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0); // will be set based on device
  const [isLive, setIsLive] = useState(false);
  const playerRef = useRef(null);
  const thumbnailRef = useRef(null);

  const isMobile = window.innerWidth <= 1023; // <1024px = mobile/tablet

  const handleEnd = useCallback(() => {
    if (!isLive && videos.length > 1) {
      setCurrentIndex((prev) => (prev + 1) % videos.length);
    }
  }, [isLive, videos.length]);

  useEffect(() => {
    fetch("https://esmaaash.in/esmaaash_web/backend/api/random_youtube_video.php")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data.videos) && data.videos.length > 0) {
          setIsLive(data.live === true);
          setVideos(data.videos);

          // Set initial video based on device type
          const mobileIndex = 1;
          const desktopIndex = 0;

          const indexToSet = isMobile ? mobileIndex : desktopIndex;
          setCurrentIndex(indexToSet < data.videos.length ? indexToSet : 0);
        }
      });

    const messageListener = (event) => {
      if (
        event.origin.includes("youtube.com") &&
        event.data?.event === "onStateChange" &&
        event.data?.info === 0
      ) {
        handleEnd();
      }
    };

    window.addEventListener("message", messageListener);
    return () => window.removeEventListener("message", messageListener);
  }, [handleEnd, isMobile]);

  const handleVideoSelect = (index) => {
    setCurrentIndex(index);
  };

  const scrollThumbnails = (direction) => {
    const container = thumbnailRef.current;
    if (container) {
      const scrollAmount = direction === "left" ? -150 : 150;
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      scrollThumbnails("right");
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const currentVideo = videos[currentIndex] || "";

  const extractVideoId = (url) => {
    if (url.includes("embed/")) {
      return url.split("embed/")[1].split("?")[0];
    } else if (url.includes("watch?v=")) {
      return url.split("watch?v=")[1].split("&")[0];
    }
    return "";
  };

  const videoId = extractVideoId(currentVideo);
  const embedUrl = videoId
    ? `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1&rel=0`
    : "";

  return (
    <div className="video-wrapper">

<motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        data-text="SMAAASH STREAM ZONE"
        className="text-3xl font-bold mt-16 mb-6"
      >
        SMAAASH STREAM ZONE
      </motion.h2>
      
      {/* Desktop/Tablet Layout */}
      <div className="desktop-view">
        {/* Left: Video */}
        <div className="video-player-desktop">
          {embedUrl && (
            <iframe
              ref={playerRef}
              src={embedUrl}
              width="100%"
              height="100%"
              title="YouTube Video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          )}
        </div>

        {/* Right: Vertical Thumbnails */}
        <div className="thumbnail-vertical">
          {videos.slice(0, 4).map((video, index) => {
            const vid = extractVideoId(video);
            return (
              <img
                key={index}
                src={`https://img.youtube.com/vi/${vid}/hqdefault.jpg`}
                alt={`Thumbnail ${index}`}
                className="thumbnail-item-vertical"
                onClick={() => handleVideoSelect(index)}
              />
            );
          })}
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="mobile-view1">
        {embedUrl && (
          <div className="video-player-mobile">
            <iframe
              ref={playerRef}
              src={embedUrl}
              width="100%"
              height="250"
              title="YouTube Video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        )}
      </div>

      {/* Bottom Scrollable Thumbnails (common for all screens) */}
      <div className="thumbnail-scroll-section">
        <div className="thumbnail-scroll" ref={thumbnailRef}>
          {videos.map((video, index) => {
            const vid = extractVideoId(video);
            return (
              <img
                key={index}
                src={`https://img.youtube.com/vi/${vid}/default.jpg`}
                alt={`Thumbnail ${index}`}
                className="thumbnail-item-horizontal"
                onClick={() => handleVideoSelect(index)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
